import { Component, OnInit } from "@angular/core";
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { of } from "rxjs";
import { Utils } from "src/app/common/utils";
import { FieldControlService } from "src/app/forms/models/field-control.service";
import { DateField } from "src/app/forms/models/field-date";
import { DropdownField } from "src/app/forms/models/field-dropdown";
import { TextboxField } from "src/app/forms/models/field-textbox";
import { AllPatient } from "src/app/models/patient";
import Swal from "sweetalert2";
import { Extend } from "./../../models/extend";
import { VproService } from "./../../service/vpro/vpro.service";
import { Location } from '@angular/common';
import { Checkin } from "src/app/models/scheckin";
import { TrimFormValuesService } from 'src/app/common/trimmingForm';
declare var $: any;
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: 'app-adhoc-newappt',
  templateUrl: './adhoc-newappt.component.html',
  styleUrls: ['./adhoc-newappt.component.css'],
  providers: [FieldControlService],
})
export class AdhocNewapptComponent implements OnInit {

  yearList: any[];
  freqList = [
    {
      id: 1,
      value: "Daily",
    },
    {
      id: 2,
      value: "Weekly",
    },
    {
      id: 3,
      value: "Monthly",
    },
    {
      id: 4,
      value: "Yearly",
    },
  ];
  statslist: any = [];
  checkin = new Checkin();
  currentDate = Utils.maxDate;
  AppointmentType = Utils.APPOINTMENT_TYPE;
  httpClient: any;
  selectedFile: File;
  allpatients = new AllPatient();
  submitted = false;
  public model: any;
  physician = [];
  ar = [0, 1, 2];
  data: any;
  extend = new Extend();
  orgdet: any;
  currentTab: string = "appetiteHabits";
  pat_stats: UntypedFormArray;
  listOfTabs: any[] = [
    {
      id: "personalInformation",
      title: "Personal Info",
    },
    {
      id: "bodyStats",
      title: "Body Stats",
    },
    {
      id: "contactDetails",
      title: "Contact Details",
    },

    {
      id: "medicalHistory",
      title: "Medical History",
    },
    {
      id: "currentMedication",
      title: "Current Medication",
    },
    {
      id: "appetiteHabits",
      title: "Appetite Habits",
    },
    {
      id: "fammedhistory",
      title: "Family Medical History",
    },
    {
      id: "lshistory",
      title: "Life Style History",
    },
  ];
  dcred: any;
  forms = {
    personalInformation: null,
    contactDetails: null,
    bodyStats: null,
    medicalHistory: null,
    currentMedication: null,
    appetiteHabits: null,
    fammedhistory: null,
    lshistory: null,
    patstats: null,
    reasonForm: null,
  };

  patient_appHabbitsList: any = [];
  patient_med_history: UntypedFormArray;
  patient_medication: UntypedFormArray;
  patient_appetite: UntypedFormArray;
  patient_fmed_history: UntypedFormArray;
  patient_lifestyle: UntypedFormArray;

  ppfile: File = null;
  ppurl: String = "";
  pp_content_type: String = "";
  form_fields = {
    personalInformation: [
      new TextboxField({
        key: "first_name",
        label: "First Name *",
        required: true,
        type: "text",
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        pattern: Utils.alphaSpaceRegex,
      }),
      new TextboxField({
        key: "last_name",
        label: "Last Name *",
        required: true,
        type: "text",
        maxlength: 30,
        pattern: Utils.alphaSpaceRegex,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
      }),
      new DateField({
        key: "dob",
        label: "Date of Birth (DD/MM/YYYY) *",
        required: true,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        maxDate: Utils.maxDate
      }),
    ],
    bodyStats: [
      new DropdownField({
        key: "gender",
        label: "Gender *",
        required: true,
        options: of([
          { key: "Male", value: "Male" },
          { key: "Female", value: "Female" },
          { key: "Other", value: "Other" },
        ]),
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
      }),
      new DropdownField({
        key: "blood_group",
        label: "Blood Group",
        options: of([
          { key: "A+", value: "A+" },
          { key: "A-", value: "A-" },
          { key: "B+", value: "B+" },
          { key: "B-", value: "B-" },
          { key: "O+", value: "O+" },
          { key: "O-", value: "O-" },
          { key: "AB+", value: "AB+" },
          { key: "AB-", value: "AB-" },
        ]),
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
      }),
      new TextboxField({
        key: "email_id",
        type: "email",
        pattern: Utils.emailpat,
        label: "Email",
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        maxlength: 50,
      }),
      new TextboxField({
        key: "contact_no",
        type: "tel",
        required: true,
        label: "Contact Number *",
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        pattern: Utils.numberRegex,
        maxlength: 10,
        minlength: 10,
      }),
      new TextboxField({
        key: "address_1",
        label: "Address Line 1",
        maxlength: 150,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
      }),
      new TextboxField({
        key: "address_2",
        label: "Address Line 2",
        maxlength: 150,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
      }),
    ],
    contactDetails: [

      new TextboxField({
        key: "city_n",
        label: "City *",
        required: true,
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        pattern: Utils.alphaRegex,

      }),
      new DropdownField({
        key: "state",
        label: "State",
        options: of(Utils.STATE),
        class: "col-12 col-sm-12 col-md-4 col-lg-4",

      }),
      new TextboxField({
        key: "zip",
        type: "tel",
        label: "Zip",
        maxlength: 6,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",

      }),
    ],
  };

  diseaseList: any = [];
  drid: number;
  currentDt: Date;
  u_id = parseInt(localStorage.getItem('uid'));
  cdt = `${this.currentDate.year}-${this.currentDate.month}-${this.currentDate.day}`;
  constructor(
    private addPService: VproService,
    private formService: FieldControlService,
    private fb: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private location: Location,
    private trimFormValuesService: TrimFormValuesService,
  ) {
    for (let form_field in this.form_fields) {
      this.forms[form_field] = this.formService.toFormGroup(
        this.form_fields[form_field]
      );
    }
    this.forms.appetiteHabits = this.fb.group({
      patient_appetite: this.fb.array([]),
    });
    this.forms.medicalHistory = this.fb.group({
      patient_med_history: this.fb.array([]),
    });

    this.forms.currentMedication = this.fb.group({
      patient_medication: this.fb.array([]),
    });


    this.forms.fammedhistory = this.fb.group({
      patient_fmed_history: this.fb.array([]),
    });

    this.forms.lshistory = this.fb.group({
      patient_lifestyle: this.fb.array([]),
    });
  }

  ngOnInit() {
    this.getOrgDet(localStorage.getItem("LogUsr"));
    this.getAppHabbitList();
    this.addingMoreMedicalHistory();
    this.addingFamilyMedicalHistory();
    this.addingLifestyle();
    this.addingCurrMedication();
    this.getDiseaseList();
    this.getYears();
    this.getStatsList();
  }

  addFamHistRecord(): UntypedFormGroup {
    return this.fb.group({
      relation: [null],
      diabetic: [null],
      cardio: [null],
      cholestral: [null],
      tension: [null],
      status: [null],
      remarks: [null],
      createdby: [this.u_id],
      createdat: [this.cdt],

    });
  }

  addLifestyleRecords(): UntypedFormGroup {
    return this.fb.group({
      activity: [null],
      duration: [null],
      freq: [null],
      createdby: [this.u_id],
      createdat: [this.cdt],

    });
  }

  addMedHistRecord(): UntypedFormGroup {
    return this.fb.group({
      disease_id: [null],
      med_hist_info: [null],
      since: [null],
      createdby: [this.u_id],
      createdat: [this.cdt],

    });
  }

  addCurrMedRecord(): UntypedFormGroup {
    return this.fb.group({
      pmed_dose: [""],
      pmed_freq: [""],
      createdby: [this.u_id],
      createdat: [this.cdt],

    });
  }



  addAppetite(id): UntypedFormGroup {
    return this.fb.group({
      habit_id: [id],
      habit_details: [null],
      has_habit: [null, [Validators.required]],
      since: [null],
      frequency: [null],
      createdby: [this.u_id],
      createdat: [this.cdt],

    });
  }

  getOrgDet(usereid: string) {
    try {
      this.addPService.getOrgDet(this.dcred).subscribe(
        (res) => {
          this.orgdet = res;
          for (let i of this.orgdet) {
            this.extend.org_code = i.org_code;
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }

  public addingFamilyMedicalHistory(): void {
    for (let i = 1; i <= 3; i++) {
      this.patient_fmed_history = this.forms.fammedhistory.get(
        "patient_fmed_history"
      ) as UntypedFormArray;
      this.patient_fmed_history.push(this.addFamHistRecord());
    }
  }

  public addingLifestyle(): void {
    for (let i = 1; i <= 3; i++) {
      this.patient_lifestyle = this.forms.lshistory.get(
        "patient_lifestyle"
      ) as UntypedFormArray;
      this.patient_lifestyle.push(this.addLifestyleRecords());
    }
  }

  /** adding more medical history */
  public addingMoreMedicalHistory(): void {
    this.patient_med_history = this.forms.medicalHistory.get(
      "patient_med_history"
    ) as UntypedFormArray;
    this.patient_med_history.push(this.addMedHistRecord());
  }



  /** removing medical history */
  public removingMedicalHistory(i: number): void {
    this.patient_med_history.removeAt(i);
  }

  /** adding current medication */
  public addingCurrMedication(): void {
    this.patient_medication = this.forms.currentMedication.get(
      "patient_medication"
    ) as UntypedFormArray;
    this.patient_medication.push(this.addCurrMedRecord());
  }

  /** remove current medication */
  public removingCurrentMedication(i: number): void {
    this.patient_medication.removeAt(i);
  }

  /** opening datepicker for entering dob fields */
  public openDatePicker() {
    $("#datetimepicker4").datetimepicker();
  }

  /** assign tabs based on click */
  public assignTab(tabName: string): void {
    this.currentTab = tabName;
  }
  /** next tabs based on next click by user */
  public nextTab(): void {
    let index = this.listOfTabs.findIndex((t: any) => t.id === this.currentTab);
    this.currentTab = this.listOfTabs[index + 1].id;
  }
  /** get previous tabname and info */
  public previousTab(): void {
    let index = this.listOfTabs.findIndex((t: any) => t.id === this.currentTab);
    this.currentTab = this.listOfTabs[index - 1].id;
  }

  get f() {
    return this.forms[this.currentTab].controls;
  }

  getAppHabbitList() {
    this.addPService.getAppHabbitList().subscribe(
      (res) => {
        this.patient_appHabbitsList = res;
        for (let apetite of this.patient_appHabbitsList) {
          this.patient_appetite = this.forms.appetiteHabits.get(
            "patient_appetite"
          ) as UntypedFormArray;
          this.patient_appetite.push(this.addAppetite(apetite.id));
        }
      },
      (error) => { }
    );
  }

  getStatsList() {
    this.addPService.getstatList().subscribe(
      (res) => {
        this.statslist = res;
        console.log("this.statslist", this.statslist)
        for (let stats of this.statslist) {
          this.pat_stats = this.forms.patstats.get(
            "pat_stats"
          ) as UntypedFormArray;
          this.pat_stats.push(this.addStats(stats.id));
        }
      },
      (error) => { }
    );
  }

  addStats(id): UntypedFormGroup {
    return this.fb.group({
      stats_id: [id],
      stats_value: [null],
    });
  }

  formValidation(i, key, arrayName) {
    let error = false;
    if (
      this.forms[this.currentTab].get([arrayName]).controls[i] &&
      this.forms[this.currentTab].get([arrayName]).controls[i].controls[key] &&
      this.forms[this.currentTab].get([arrayName]).controls[i].controls[key]
        .errors
    ) {
      error = true;
    }
    console.log("e", error);
    return error;
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  savePatient() {
    this.drid = parseInt(localStorage.getItem("uid"));
    let data = {
      ...this.forms.personalInformation.value,
      ...this.forms.contactDetails.value,
      ...this.forms.bodyStats.value,
      ...this.forms.medicalHistory.value,
      ...this.forms.currentMedication.value,
      ...this.forms.appetiteHabits.value,
      ...this.forms.fammedhistory.value,
      ...this.forms.lshistory.value,
      org_code: this.extend.org_code,
    };
    if (data.first_name == null || data.last_name == null || data.contact_no == null || data.dob == null || data.city_n == null || data.gender == null) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3500,
      });
      Toast.fire({
        type: "error",
        title: "Please fill all required (*) Fields",
      });
      return null;
    }
    if (data.first_name && data.last_name) {
      data.first_name = data.first_name.charAt(0).toUpperCase() + data.first_name.slice(1).toLowerCase();
      data.last_name = data.last_name.charAt(0).toUpperCase() + data.last_name.slice(1).toLowerCase();
    }
    if (data.email_id) {
      data.email_id = data.email_id.toLowerCase();
    }
    if (data.dob) {
      data.dob = `${data.dob.year}-${data.dob.month}-${data.dob.day}`;
    }
    data.contact_no = parseInt(data.contact_no);
    data.createdby = this.u_id;
    data.createdat = this.cdt;

    data = Utils.removeNullAndEmpty(data);
    if (data.patient_fmed_history && data.patient_fmed_history.length > 0) {
      let ik = 0;
      data.patient_fmed_history.forEach((x) => {
        if (ik == 0)
          x.relation = "FATHER";
        else if (ik == 1)
          x.relation = "MOTHER";
        else if (ik == 2)
          x.relation = "SIBLINGS";
        ik++;
      });
    }
    if (data.patient_lifestyle && data.patient_lifestyle.length > 0) {
      let ik = 0;
      data.patient_lifestyle.forEach((x) => {
        if (ik == 0)
          x.activity = "EXERCISE";
        else if (ik == 1)
          x.activity = "WALKING / RUNNING";
        else if (ik == 2)
          x.activity = "WORKING HOURS";
        ik++;
      });
    }
    if (data.patient_med_history && data.patient_med_history.length > 0) {
      data.patient_med_history.forEach((x, index) => {
        data.patient_med_history[index] = Utils.removeNullAndEmpty(
          data.patient_med_history[index]
        );
      });
      data.patient_med_history = data.patient_med_history.filter(
        (x) => x.disease_id || x.since || x.med_hist_info
      );
    }
    if (data.patient_medication && data.patient_medication.length > 0) {
      data.patient_medication.forEach((x, index) => {
        data.patient_medication[index] = Utils.removeNullAndEmpty(
          data.patient_medication[index]
        );
      });
      data.patient_medication = data.patient_medication.filter(
        (x) => x.pmed_dose || x.pmed_freq
      );
    }
    if (data.patient_appetite && data.patient_appetite.length === 0) {
      delete data.patient_appetite;
    }
    if (data.patient_appetite && data.patient_appetite.length > 0) {
      data.patient_appetite.forEach((x, index) => {
        if (x.has_habit && x.has_habit === "Yes") {
          x.has_habit = true;
        } else x.has_habit = false;

      });
      data.patient_med_history = data.patient_med_history.filter(
        (x) => x.disease_id || x.since || x.med_hist_info
      );
    }
    if (data.patient_lifestyle && data.patient_lifestyle.length === 0) {
      delete data.patient_lifestyle;
    }
    if (data.patient_fmed_history && data.patient_fmed_history.length === 0) {
      delete data.patient_fmed_history;
    }
    if (data.patient_medication && data.patient_medication.length === 0) {
      delete data.patient_medication;
    }
    if (data.patient_med_history && data.patient_med_history.length === 0) {
      delete data.patient_med_history;
    }
    if (this.ppurl && this.pp_content_type) {
      data.ppurl = this.ppurl;
      data.pp_content_type = this.pp_content_type;
    }
    this.spinner.show();

    this.trimFormValuesService.trimValues(data);
    this.addPService.newaddPatients(data, this.ppfile).subscribe(
      (res: any) => {
        let { pid, aptname } = res;
        console.log("aptname", aptname)

        ////////////////////    Auto schedule and checkin bypass    ///////////////////////////
        let { day: startDay, month: startMonth, year: startYear } = this.currentDate;
        var today = new Date();
        var date = today.getDate();
        var month = today.getMonth() + 1;
        var year = today.getFullYear();
        let hours = today.getHours();
        let minutes = today.getMinutes();
        var current_date = year + '-' + month + '-' + date;
        let data = {
          reason: "Adhoc appointmnet",
          type: this.AppointmentType.IN_PERSON,
          pid: pid,
          drid: JSON.parse(localStorage.getItem("uid")),
          aptname: aptname,
          apdate: startYear + "-" + startMonth + "-" + startDay,
          aptime: hours + ':' + minutes,
          uid: JSON.parse(localStorage.getItem("uid")),
          createdat: this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day
        };
        this.addPService.addAdhocSchedule(data).subscribe(
          (res: any) => {
            let { aid } = res;
            let datas = {
              patient_checkin_stats: this.statslist,
              reason: "Adhoc appointmnet checkin",
              aid: parseInt(aid),

            };
            if (datas.patient_checkin_stats && datas.patient_checkin_stats.length > 0) {
              datas.patient_checkin_stats.forEach((x, index) => {
                x.stats_std_val = null;
                x.aid = parseInt(aid);
                x.pid = pid;
                x.stats_date_time = current_date;
                x.stats_id = x.id;
                x.stats_by = this.drid;
                delete x.id;
                delete x.stats_comp;
                delete x.stats_name;
                delete x.stats_std_uom;
                delete x.stats_std_val_from;
                delete x.stats_std_val_to;
                delete x.stats_std_value;
                delete x.stats_type;
              });
            }
            console.log("DATA", datas);
            this.addPService.saveCheckin_stats(datas).subscribe(
              () => {
                this.checkin['chkinby'] = this.drid
                this.addPService.Checkin_s(aid, this.checkin).subscribe((result) => {
                  // let consult_screen = "/appointment/consultation"
                  // this.router.navigate([consult_screen]);
                  let consult_screen = "/phydash/" + pid
                  this.router.navigate([consult_screen], {
                    queryParams: { cid: parseInt(aid) }
                  });
                  console.log("consult_screen", consult_screen)
                  this.spinner.hide();
                }, (err) => {
                  console.log(err);
                });
              },
              (error) => {
                this.spinner.hide();
                const Toast = Swal.mixin({
                  toast: true,
                  position: "top",
                  showConfirmButton: false,
                  timer: 3500,
                });
                Toast.fire({
                  type: "error",
                  title: "Something went wrong. Please try again later.",
                });
              }
            );
          },
          err => {
            this.spinner.hide();
            console.log(err);
            let message = "Something wrong. Couldn't schedule appointment.";
            if (err && err.error && err.error.error) {
              this.showToast('error', err.error.error);
              return;
            }
            this.showToast('error', message);
          }
        );
        ////////////////////    Auto schedule and checkin bypass    ///////////////////////////

      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: error && error.error.message
            ? error.error.message
            : "Something went wrong. Please try again later.",
        });
      }
    );
  }

  public fileSelected(files) {
    if (files[0].type && files[0].type.indexOf('image') === -1) {
      const Toast = Swal.mixin({
        position: 'top',
        showConfirmButton: true,
        allowOutsideClick: false,
      });
      Toast.fire({
        type: 'warning',
        title: 'Only .png/.jpeg/.jpg format is allowed',
      });
    }
    if (files && files.length > 0) {
      this.ppfile = files[0];

      this.ppurl = files[0].name;
      this.pp_content_type = files[0].type;
    }
  }

  getDiseaseList() {
    this.addPService.getDiseaseList().subscribe((res) => {
      this.diseaseList = res;
    });
  }

  public getApetitleLabel(i) {
    return this.patient_appHabbitsList[i].description;
  }

  getback() {
    this.location.back();
  }

  public getYears() {
    const resultArray = [];

    for (let i = 1950; i <= (new Date()).getFullYear(); i++) {
      resultArray.push(i);
    }
    this.yearList = resultArray.reverse();
    console.log(this.yearList);
  }
}